export const uiActionTypes = {
  START_ACTION: '@ui/start_action',
  STOP_ACTION: '@ui/stop_action'
};

export const accountActionTypes = {
  NEED_SMS: '@account/needsms',
  ACCOUNT_SUCCESS: '@account/success',
  ACCOUNT_FAILURE: '@account/failure',
  LOGOUT: '@account/logout',
  LOAD_USER: '@account/load-user',
  CHANGE_PASSWORD: '@account/change-password',
  SET_STATUS: '@account/set-status',
  SET_ERROR: '@account/set-error'
};

export const auditActionTypes = {
  GET_FIELDS_SUCCESS: '@audit/get-fileds-success',
  SEARCH_SUCCESS: '@audit/search-success',
  SEARCH_CLEAR: '@audit/search-clear',
  EXPORT_SUCCESS: '@audit/export-success',
  SET_STATUS: '@audit/set-status',
  FAILURE: '@audit/failure',
  SAVE_SUCCESS: '@audit/save-success',
  GET_ALL_SUCCESS: '@audit/get-all-success',
  DELETE_SUCCESS: '@audit/delete-success',
  CLEAR_MESSAGES: '@audit/clear_messages',
};

export const documentActionTypes = {
  SEARCH_SUCCESS: '@doc/search-success',
  GET_SUCCESS: '@doc/get-success',
  GET_FILE_SUCCESS: '@doc/get-file-success',
  GET_ZIP_SUCCESS: '@doc/get-zip-success',
  UPLOAD_SUCCESS: '@doc/upload-success',
  UPDATE_SUCCESS: '@doc/update-success',
  DOWNLOAD_SUCCESS: '@doc/download-success',
  EMAIL_SUCCESS: '@doc/email-success',
  CLEAR_LIST: '@doc/clear_list',
  CLEAR_SELECTED: '@doc/clear_selected',
  CLEAR_MESSAGES: '@doc/clear_messages',
  FAILURE: '@doc/failure'
};

export const repositoryActionTypes = {
  GET_ALL_SUCCESS: '@repository/get-all-success',
  GET_USER_SUCCESS: '@repository/get-user-success',
  GET_SUCCESS: '@repository/get-success',
  UPDATE_SUCCESS: '@repository/update-success',
  CLEAR_MESSAGES: '@repository/clear_messages',
  FAILURE: '@repository/failure'
};

export const siteActionTypes = {
  GET_VERSION_SUCCESS: '@site/get-version-success',
  GET_ALL_SUCCESS: '@site/get-all-success',
  UPDATE_SUCCESS: '@site/update-success',
  CLEAR_MESSAGES: '@site/clear_messages',
  FAILURE: '@site/failure'
};

export const roleActionTypes = {
  GET_ALL_SUCCESS: '@role/get-all-success',
  GET_SUCCESS: '@role/get-success',
  GET_REPOSITORIES_SUCCESS: '@roles/get-repositories-success',
  GET_USERS_SUCCESS: '@roles/get-users-success',
  DELETE_SUCCESS: '@role/delete-success',
  UPDATE_SUCCESS: '@role/update-success',
  CREATE_SUCCESS: '@role/create-success',
  FAILURE: '@role/failure',
  CLEAR_MESSAGES: '@role/clear_messages'
};

export const savedSearchActionTypes = {
  SAVE_SUCCESS: '@savedSearch/save-success',
  GET_ALL_SUCCESS: '@savedSearch/get-all-success',
  DELETE_SUCCESS: '@savedSearch/delete-success',
  FAILURE: '@savedSearch/failure',
  CLEAR_MESSAGES: '@savedSearch/clear_messages'
};

export const userActionTypes = {
  GET_ALL_SUCCESS: '@user/get-all-success',
  GET_SUCCESS: '@user/get-success',
  CREATE_SUCCESS: '@user/create-success',
  UPDATE_SUCCESS: '@user/update-success',
  DELETE_SUCCESS: '@user/delete-success',
  FAILURE: '@user/failure',
  CLEAR_MESSAGES: '@user/clear_messages'
};

export const policyActionTypes = {
  GET_ALL_SUCCESS: '@policy/get-all-success',
  GET_SUCCESS: '@policy/get-success',
  GET_USERS_SUCCESS: '@policies/get-users-success',
  GET_REPOSITORIES_SUCCESS: '@policies/get-repositories-success',
  DELETE_SUCCESS: '@policy/delete-success',
  UPDATE_SUCCESS: '@policy/update-success',
  CREATE_SUCCESS: '@policy/create-success',
  FAILURE: '@policy/failure',
  CLEAR_MESSAGES: '@policy/clear_messages'
};
